import { render, staticRenderFns } from "./purchase-edit.vue?vue&type=template&id=58d01fcc&scoped=true&"
import script from "./purchase-edit.vue?vue&type=script&lang=ts&"
export * from "./purchase-edit.vue?vue&type=script&lang=ts&"
import style0 from "./purchase-edit.vue?vue&type=style&index=0&id=58d01fcc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d01fcc",
  null
  
)

export default component.exports